import { DataItem, ScheduledJob } from "@/types/common.types";
import { ArrowLeftIcon } from "lucide-react";
import { useMemo } from "react";
import DataSection from "../common/DataSection";
import Text from "../common/Text";
import { InsightDetailForJobTable } from "./table";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";

type JobDetailProps = {
  job: ScheduledJob;
  onDateClick: (date: string) => void;
  onBack: () => void;
};

const getJobDetails = (job: ScheduledJob): DataItem<string>[][] => {
  return [[{ label: "Insights Name:", value: job.jobName }]];
};

const InsightDetailForJob: React.FC<JobDetailProps> = ({
  job,
  onBack,
  onDateClick,
}) => {
  const jobDetails = useMemo(() => getJobDetails(job), [job]);
  const { sendEvent } = useAnalyticsManager();
  sendEvent("insight_detail_screen_viewed", {
    dataset_id: job.id.toString(),
    dataset_name: job.jobName,
    total_insight_windows: job.totalStyleIds, // assuming this is the total windows
  });
  return (
    <>
      <div className="flex w-full flex-1 items-start gap-2">
        <ArrowLeftIcon
          className="mt-2 cursor-pointer text-[#1C1B1F]"
          onClick={() => {
            sendEvent("back_to_job_list_clicked", {
              job_id: job.id,
            });

            onBack();
          }}
        />
        <div className="flex w-full flex-col gap-4">
          <h1 className="font-display text-[34px] font-medium leading-[1.05] tracking-[-0.02em] text-brand-text">
            Insights.
          </h1>
          <div className="flex flex-wrap items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-brand-muted">
            <span>Insights</span>
            <span className="text-brand-border">/</span>
            <span>{job.jobName}</span>
          </div>
        </div>
      </div>
      <DataSection dataRows={jobDetails} className="mb-5 mt-6" />
      <InsightDetailForJobTable job={job} onDateClick={onDateClick} />
    </>
  );
};

export default InsightDetailForJob;
